import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";
import {SettingsParentSection} from "../../const";

export default class SettingsModuleViewsAccess extends SettingsModule {

    constructor() {
        super({
            name                     : "Views Access",
            description              : "Manage your team's workspace. You can decide which views will be created by default, as well as grant access to custom views based on their organizational permissions.",
            svgIcon                  : "isvg-view-access",
            typeLabel                : "Organization account",
            settingsUrl              : "settings/views-access",
            settingsMenuTopCategory  : SettingsMenuTopCategory.ORGANIZATION
        });

        this.parentSection          = SettingsParentSection.VIEWS
        this._isEnabled             = true
        this.canDisable             = false
        this.hasStatus              = true
    }

}
